export function SafeLocalState(key: string, value: string) {
    localStorage.setItem(key, value);
};

export function GetLocalState(key: string, defaultValue: string) {
    var value = localStorage.getItem(key);
    if (value !== null) { return JSON.parse(value || ""); }
    return defaultValue;
};
